<template>
  <px-custom-dialog transition="fadet"
                    width="1200"
                    v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
        <v-btn icon v-on="on">
          <v-icon>
            mdi-eye
          </v-icon>
        </v-btn>
      </slot>
    </template>
    <template v-slot:title>
      Nota fiscal
    </template>
    <div v-if="notaFiscal.id && dialog">
      <px-nota-fiscal-detalhe :nota-fiscal-id="notaFiscal.id"/>
    </div>
  </px-custom-dialog>
</template>

<script>
import NotaFiscalDetalhe from '@/modules/notas-fiscais/detalhes/NotaFiscalDetalhe.vue';

export default {
  props: {
    notaFiscal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  components: {
    pxNotaFiscalDetalhe: NotaFiscalDetalhe,
  },
};
</script>
